import styled, { css } from 'styled-components';
import Card from 'components/generic/card';
import imageOverlayStyle from 'components/shared/style/imageOverlay';
import { breakpoint } from 'variables';

export const ProductCard = styled(Card)`
    background-color: transparent;
    ${({ theme }) => (theme as any).ProductCard};
`;

export const ProductContent = styled(Card.Content)`
    display: grid;
    grid-template-rows: min-content auto auto;
    text-decoration: none;
    padding: 0;
`;

export const ProductCardTop = styled.div<{ $isChanel?: boolean }>`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding: ${({ theme }) => `${theme.Spacing48} ${theme.Spacing4} ${theme.Spacing16}`};
    width: 100%;
    border-radius: ${({ theme }) => theme.RadiusMedium};
    overflow: hidden;
    background-color: ${({ theme }) => theme.ColorBackgroundPrimary};

    ${({ $isChanel }) =>
        !$isChanel &&
        css`
            &:after {
                content: '';
                ${imageOverlayStyle}
            }
        `}

    ${breakpoint.up('768px')} {
        padding: ${({ theme }) => `${theme.Spacing48} ${theme.Spacing16} ${theme.Spacing16}`};
    }

    ${({ theme }) => (theme as any).ProductCardTop}
`;

export const ProductCardMid = styled.div`
    display: grid;
    gap: ${({ theme }) => theme.Spacing8};
    align-self: flex-start;
    grid-template-rows: repeat(auto-fit, minmax(16px, auto));
    padding-bottom: ${({ theme }) => (theme as any).Spacing8};
    ${({ theme }) => (theme as any).ProductCardMid}
`;

export const ProductCardBottom = styled.div`
    display: grid;
    align-self: flex-end;
    grid-template-columns: 1fr 40px;
    gap: ${({ theme }) => theme.Spacing8};
    margin-top: ${({ theme }) => theme.Spacing8};
    ${({ theme }) => (theme as any).ProductCardBottom}
`;
